import { createSlice } from "@reduxjs/toolkit";

const GetSupplyOrderStatusSlice = createSlice({
  name: "GetSupplyOrderStatusService",
  initialState: {
    loading: false,
    orderSupplyStatusData: null,
    error: null,
    success: false
  },
  reducers: {
    GetSupplyOrderStatusInit(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    GetSupplyOrderStatusSuccess(state, action) {
      state.loading = false;
      state.orderSupplyStatusData = action.payload;
      state.success = true;
    },
    GetSupplyOrderStatusFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    GetSupplyOrderStatusReset(state) {
      return { ...state, loading: false, orderSupplyStatusData: null, success: false, error: null };
    }
  }
});

export const {
  GetSupplyOrderStatusInit,
  GetSupplyOrderStatusSuccess,
  GetSupplyOrderStatusFailure,
  GetSupplyOrderStatusReset
} = GetSupplyOrderStatusSlice.actions;

export default GetSupplyOrderStatusSlice.reducer;
